const schoolDashboardActionPrefix = '@school-dashboard/';

/* List of Redux constants */
export const SCHOOL_DASHBOARD_SET_LOADING = `${schoolDashboardActionPrefix}set-loading`;
export const SCHOOL_DASHBOARD_SET_DATA = `${schoolDashboardActionPrefix}set-data`;
export const SCHOOL_DASHBOARD_RESET_DATA = `${schoolDashboardActionPrefix}reset-data`;

/* List of Sagas constants */
export const SCHOOL_DASHBOARD_GET_DATA = `${schoolDashboardActionPrefix}get-data`;



// WEBPACK FOOTER //
// ./src/actions/school-dashboard/types.js